import { useEffect, useState } from "react";
import { SelectBox } from 'devextreme-react/select-box';

function LVSelectBox({ textoLabel, textoSelectBox, data, campoCodigo, campoDescripcion, ancho, onValueChanged, value, visible = true, readOnly = false, isLoading = false }) {
  const [comboData, setComboData] = useState([]);

  useEffect(() => {
    if (isLoading) {
      setComboData([{ [campoCodigo]: null, [campoDescripcion]: 'Cargando datos...' }]);
    } else if (!data || data.length === 0) {
      setComboData([{ [campoCodigo]: null, [campoDescripcion]: 'No hay datos disponibles' }]);
    } else {
      setComboData(data);
    }
  }, [isLoading, data]);

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '5px' }}>
      {textoLabel}
      <SelectBox
        placeholder={textoSelectBox}
        id="custom-templates"
        dataSource={(comboData && comboData.length > 0) ? comboData : [{ [campoCodigo]: null, [campoDescripcion]: 'Cargando datos...' }]}
        displayExpr={campoDescripcion}
        valueExpr={campoCodigo}
        searchEnabled={true}
        width={ancho}
        onValueChanged={onValueChanged}
        value={value}
        visible={visible}
        readOnly={readOnly}
      />
      <br />
    </div>
  );
}

export default LVSelectBox

